export enum OTP_ENUM {
  SING_UP = 1,
  LOGIN = 2,
  FORGOT_PASSWORD = 3,
  UPDATE_PASSWORD = 4,
}

export enum ROLES {
  USER = 1,
  ADMIN = 2,
  SUB_ADMIN = 3,
  MAINTAINER = 4,
}

export enum NOTIFICATION_TYPE {
  PUSH = 2,
  MAIL = 4,
}

export const ROLES_NAME: Record<number, string> = {
  1: "USER",
  2: "ADMIN",
  3: "SUB_ADMIN",
  4: "MAINTAINER",
  5: "All",
};

export const NOTIFICATION_TYPE_NAME: Record<number, string> = {
  1: "Email",
  2: "Notification",
};

export enum CUSTOMER_ONBOARDING_STEP {
  PERSONAL_DETAIL = 1,
  PROPERTY_DETAIL = 2,
  DOCUMENTS = 3,
}

export enum PROPERTY_TYPE {
  HOME = 1,
  VILLA = 2,
  APARTMENT = 3,
  BUILDING = 4,
}

export enum DOCUMENT_TYPE {
  PASS_P0RT = 1,
  EMIRATES_ID = 2,
  BUSINESS_LICENSE = 3,
}

export enum USER_STATUS {
  APPROVED = 1,
  PENDING = 2,
  REJECTED = 3,
}

export enum ISSUE_STATUS {
  PENDING = 1,
  ONGOING = 2,
  COMPLETED = 3,
}

export enum OFFER_STATUS {
  PENDING = 1,
  ACCEPTED = 2, // ACCEPTED BY ADMIN
  APPROVED = 3, // APPROVED BY USER,
  SCHEDULED = 4,
  INPROGRESS = 5,
  COMPLETED = 6,
  REJECTED = 7,
}

export enum CUSTOMER_QUERY {
  PENDING = 1,
  RESOLVED = 2,
}

export enum GRAPH_TYPE {
  USER_GRAPH = 1,
  SP_GRAPH = 2,
  ISSUE_GRAPH = 3,
  EARNING_GRAPH = 4,
}

export enum GRAPH_TYPE_DAILY {
  DAILY = "daily",
  WEEKLY = "weekly",
  MONTHLY = "monthly",
  YEARLY = "yearly",
}

export enum SENT_NOTIFICATION {
  DEFAULT = 0,
  BROADCAST = 1,
  ISSUE_STATUS_UPDATE = 2,
  NEW_USER_ONBOARD = 3,
}

export enum PAYMENT_STATUS {
  PENDING = 1,
  SUCCEEDED = 2,
  FAILED = 3,
  REFUNDED = 4,
}
